import i18n from '@/i18n';
import store from "@/store";
import S_base from '@/service/api/v1/__base';
import S_Processor from '@/service/app/processor';
import S_wasaBase from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index({ params }) {
    return S_base.index({
      preUrl: S_Processor.getFactoryPreUrl(),
      modelName: 'system_class',
      params: params,
    });
  },
  async fetchSystemClassesForFactory(factoryId, params) {
    return S_wasaBase.index({
      preUrl: `factory/${factoryId}`,
      modelName: 'system_class',
      params,
    });
  },
  setSystemClassesItems(list) {
    const scopeIds = new Set(
      (store.state.auth.systemSubclasses || []).map(item => item.id),
    );
    return (list || []).map(({ id, name, system_subclasses = [] }) => ({
      id,
      title: name,
      menu: system_subclasses.map((systemItem) => ({
        text: systemItem.name,
        value: systemItem.id,
        color: scopeIds.has(systemItem.id) ? undefined : 'red',
      })),
    }));
  },
  setAllSystemClassesSelect(systemClasses) {
    //[14, 15, 16, 17, 18, 19, 23, 24, 21, 22, 20, 26]
    let allSystem = [];
    systemClasses.forEach((systemClass) => {
      systemClass.system_subclasses.forEach((subclass) => {
        allSystem.push(subclass.id);
      });
    });
    return allSystem;
  },
  getSelectedSystemClasses(systemSubclassesList, systemList) {
    const subclassSet = new Set(systemSubclassesList || []);
    const selectSystemSet = new Set();
    systemList.forEach((items) => {
      if (items.menu?.some(item => subclassSet.has(item.value))) {
        selectSystemSet.add(items.id);
      }
    });
    return [...selectSystemSet];
  },
  getSelectedSystemClassSingle(systemSubclass, systemList) {
    let selectSystem = null;
    systemList.forEach((items) => {
      let itemId = items.id;
      items.menu.forEach((item) => {
        if (systemSubclass === item.value) {
          selectSystem = itemId;
        }
      });
    });
    return selectSystem;
  },
  getSystemClassItems(systemClasses) {
    //用於dashboard合規排行榜的領域下拉
    let items = [
      {
        id: 'all',
        textLabel: i18n.t('全部'),
      },
    ];
    const systemClassItems = systemClasses.map((item) => {
      return {
        id: item.id.toString(),
        textLabel: item.name,
      };
    });
    items = [...items, ...systemClassItems];
    return items;
  },
};
